import { useDispatch, useSelector } from "react-redux";

import {Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";
import {getAcompanhamentoOS, getDiarioProducao} from "../../../actions/orderActions"
import {getEtapas} from "../../../actions/stationActions";

import CircularProgress from "@material-ui/core/CircularProgress";
import ListaOS from "./listaOS";
import {getPneusNaCasa} from "../../../actions/i4Actions";
import ExportarPneusEmCasaXLS from "./exportarPneusEmCasaXLS";


const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

//TODO: Desenvolver Card de etapas concluidas por OS
// Cada linha uma OS
// Colunas para cada etapa, semelhante diario de producao
// coloracao do grid mais clara ou escura de acordo com a media de tempo
// vermelho se estiver fora dos tempos min e max
//

const PneusEmCasa = ({

                    }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);

    const pneusNaCasa = useSelector( state => state.i4.pneusNaCasa);

    const dispatch = useDispatch();


    useEffect( () => {
        dispatch(getPneusNaCasa());
    }, []);



    return (
        <React.Fragment>

            <Grid item  xs={12} sm={12} lg={12} xl={12}>
                <Typography variant="h4" align="center" className={classes.sectionTitle}>
                    PNEUS EM CASA <ExportarPneusEmCasaXLS dataSet={pneusNaCasa}/>
                </Typography>

            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>


                    <React.Fragment>


                               <ListaOS listaOrdensServico={pneusNaCasa}/>


                    </React.Fragment>





            </Grid>
        </React.Fragment>
    )

}

export default PneusEmCasa;
